export default "<h1>Welcome to Laer</h1>\n\n<div class=\"login\">\n\n</div>"